import { useEventBus } from 'src/hooks';
import ThemeManager from '../ThemeManager';

const REDUX_CONFIG_KEY = 'evolutiveCrossChartConfigData';

export default class EvolutiveCrossChartThemeManager extends ThemeManager {
  constructor(
    analyzeId,
    surveyId,
    withData,
    chartRef,
    appTheme,
    chartType,
    cardType,
    consolidations
  ) {
    super(
      analyzeId,
      surveyId,
      withData,
      chartRef,
      appTheme,
      chartType,
      cardType,
      consolidations
    );
    this._eventBus = useEventBus();

    // Bindings
    this._recalculateColorArray = this._recalculateColorArray.bind(this);
    this._setChartConfiguration = this._setChartConfiguration.bind(this);
    this._setChartSeries = this._setChartSeries.bind(this);
    this._setActions = this._setActions.bind(this);
    this._setChartColorsOnInit = this._setChartColorsOnInit.bind(this);
    this._setChartInitializationState =
      this._setChartInitializationState.bind(this);
    this.setColorChangedEventHandler =
      this.setColorChangedEventHandler.bind(this);

    // Utilização do hook que armazena os dados de series do gráfico atual
    this._setChartSeries();
    // Seta as configurações do gráfico atrelados ao redux (payload | fontsSizes | error | ... |)
    this._setChartConfiguration(REDUX_CONFIG_KEY);
    // Prepara as ações de atualização de configuração do gráfico (updateChartColor | updateFontSize | updateColorScheme)
    // para utilização na instância
    this._setActions();

    this._setChartInitializationState();
    this._setChartColorsOnInit();
  }

}
